import { FeatureStateShape } from 'store';

export default {
	features: []
} as FeatureStateShape;
